import { Component, Input } from '@angular/core';
import { Block } from '@core/models/block/block.model';

@Component({
    selector: 'app-filter-search-input',
    template: `
    <div app-block
         *ngFor="let block of block.children"
         [appClickableBlock]="block"
         [class]="block.uId"
         [item]="block"></div>
         `,
    styles: [
        `
      :host
      ::ng-deep
      .mat-mdc-form-field-appearance-outline
      .mat-mdc-form-field-wrapper {
        margin: 0 !important;
        padding-bottom: 0 !important;
      }

      :host {
        all: inherit;
      }
    `,
    ],
    standalone: false
})
export class FilterSearchInputComponent {
  @Input() block: Block;
}
